import AlwaysOn from '../img/icon-always-on.svg';
import Cooking from '../img/icon-cooking.svg';
import Entertainment from '../img/icon-entertainment.svg';
import Laundry from '../img/icon-laundry.svg';
import Lighting from '../img/icon-lighting.svg';
import Other from '../img/icon-other.svg';
import PoolPump from '../img/icon-pool-pump.svg';
import Refrigeration from '../img/icon-refrigeration.svg';
import WholeHome from '../img/icon-whole-home.svg';
import WaterHeating from '../img/icon-water-heating.svg';
import Cooling from '../img/icon-cooling.svg';
import ElectricVehicle from '../img/icon-ev.svg';
import Heating from '../img/icon-heating.svg';

export const APPLIANCES_ID_TO_DETAILS = {
  4 : {name : "Air Conditioning", iconClassName : 'ac'},
  3 : {name : "Space Heating", iconClassName : 'heating'},
  8 : {name : "Always On", iconClassName : 'always-on'},
  2 : {name : "Pool", iconClassName : 'pool-pump'},
  59: {name : "Laundry & Cleaning", iconClassName : 'laundry'},
  66: {name : "Entertainment", iconClassName : 'entertainment'},
  71: {name : "Lighting", iconClassName : 'lighting'},
  9 : {name : "Refrigeration", iconClassName : 'refrigerator'},
  7 : {name : "Water Heating", iconClassName : 'water-heater'},
  18: {name : "Electric Vehicle", iconClassName : 'ev'},
  5 : {name : "Cooking", iconClassName : 'cooking'},
  99: {name : "Other", iconClassName : 'other-electric'}
};

export const RECO_APPLIANCE_LIST_ICONS = {
  0: WholeHome,
  8: AlwaysOn,
  2: PoolPump,
  59: Laundry,
  66: Entertainment,
  71: Lighting,
  9: Refrigeration,
  7: WaterHeating,
  18: ElectricVehicle,
  4: Cooling,
  3: Heating,
  5: Cooking,
  99: Other
};

export const SELECT_ALL = 'SELECT_ALL';
export const WHOLE_HOME = 'WHOLE_HOME';
export const WHOLE_HOME_ICON = WholeHome;
export const HOME_SURVEY = 'Home Survey';

export const EFFORT_LIST = ["Easy", "Medium", "Hard"];
export const COST_LIST = [1, 2, 3, 4, 5];
export const UNITS = {
  "kWh": "kWh",
  "$": "$",
  "CCF": "CCF"
};

export const INSIGHTS_USAGE_COLORS = {
  "8": "--color_62",
  "4": "--color_1",
  "59": "--color_67",
  "18": "--color_72",
  "7": "--color_61",
  "2": "--color_73",
  "5": "--color_64",
  "9": "--color_63",
  "66": "--color_66",
  "3": "--color_60",
  "71": "--color_68",
  "99": "--color_70"
};

export const BAR_COLOR = '--color_17';
export const BAR_HOVER_COLOR = '--color_39';
export const NA = {
  NAME: "NA",
  COLOR: "--color_37"
};
export const ONGOING = {
  NAME: "Ongoing",
  COLOR: "--color_38"
};
export const TEMPERATURE = {
  NAME: "Temperature",
  COLOR: "--color_71",
  FILL_COLOR: "--color_7",
  GRAPH_TYPE: "spline"
};

export const USAGE_COLORS = {
  ITEMIZATION_LEGEND_COLOR: "--color_2",
  ITEMIZATION_WEEKEND_COLOR: '--color_12',
  TOOLTIP_BACKGROUND_COLOR: "--color_7"
};

export const DEFAULT_FONT_FAMILY = "Montserrat";

export const FONT_WEIGHT = {
  light: 100,
  semiLight : 300,
  normal: 400,
  medium: 500,
  bold: 600
};

export const CHANNEL_TYPES = {
  EMAIL: "email",
  SMS: "sms",
  WEB: "web"
};

export const BUDGET_THRESHOLD_AMOUNT = "BUDGET_THRESHOLD_AMOUNT";
export const BUDGET_ALERT = "BUDGET_ALERT";

export const TIMESCALE = {
  YEAR: "Year",
  MONTH: "Month",
  DAY: "Day",
  HOUR: 'Hour',
};
export const NA_FALLBACK_TEXT = "N/A";

export const FUEL_TYPE = {
  GAS: 'gas',
  ELECTRIC: 'electric'
};
export const USAGE_TYPE = {
  COST: 'cost',
  ENERGY: 'energy',
  USAGE: 'usage',
  PERCENTAGE : 'percentage'
};

export const LIKE = 'Like';

export const GRAPH_STYLE = {
  COLUMN: "column",
  AREA: "area"
};

export const TOTAL = 'Total';
export const WEATHER = 'Weather';

export const PENDING = 'PENDING';
export const SUCCESS = 'SUCCESS';
export const FAILURE = 'FAILURE';
export const TIMEOUT = 'TIMEOUT';


export const USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW = 13;
export const USAGE_DASHBOARD_HOUR_ITEMS_TO_SHOW = 13;

export const USAGE_CHART_EVENTS = {
  CHANGE_MODE: "changeMode",
  TOGGLE_GAS_ELECTRIC: "toggleGasElectric",
  CHANGE_MONTH_OFFSET: "changeMonthOffset",
  CHANGE_DAY_OFFSET: "changeDayOffset",
  SET_HIGHCHARTS_DATA: "setHighchartsData",
  CHANGE_YEAR_OFFSET: "changeYearOffset",
  CHANGE_HOUR_OFFSET: "changeHourOffset",
  FETCH_MONTH_FROM_YEAR: "fetchMonthFromYear",
  FETCH_DATE_FROM_MONTH: "fetchDateFromMonth",
  FETCH_HOUR_FROM_DAY: "fetchHourFromDay",
  SHOW_DATA_NOT_AVAILABLE: "showDataNotAvailable",
  SAVE_YEAR_DATA: "saveYearData",
  SAVE_HOUR_DATA: "saveHourData",
  SAVE_MONTH_DATA: "saveMonthData",
  SAVE_DAY_DATA: "saveDayData",
  SAVE_BILLING_CYCLE_INFO: "saveBillingCycleInfo",
  SHOW_DATA_EMPTY: "showDataEmpty",
  CHANGE_GRAPH_STYLE: "changeGraphStyle",
  TOGGLE_DROPDOWN: "toggleDropdown",
  TOGGLE_COST_ENERGY: "toggleCostEnergy",
  TOGGLE_WEATHER: "toggleWeather",
  UPDATE_HIGHCHARTS_OBJECT: "updateHighChartsObject",
  CHECK_ARROW_DISABLED: "checkArrowDisabled",
  SET_PROPS_FOR_COST_OR_CONSUMPTION: "setPropsForCostOrCosnumptionMode"
};

export const USAGE_SHC_EVENTS = {
  CHANGE_YEAR_OFFSET: 'changeYearOffset',
  UPDATE_HIGHCHARTS_OBJECT: 'updateHighchartsObject',
  SET_SHC_DATA: 'setSHCData',
  SAVE_BC_DATA: 'saveBCData',
  SAVE_SHC_CHART_DATA_PAYLOAD: 'saveSHCChartDataPayload',
  CHANGE_SELECTED_APPLIANCE: 'changeSelectedAppliance',
  SET_DATA_NOT_AVAILABLE: 'setDataNotAvailable',
  SET_ARROW_DISABLED: 'setArrowDisabled',
  SET_HIGHCHARTS_DATA: 'setHighchartsData',
  SAVE_BILLING_CYCLE_INFO: 'saveBillingCycleInfo',
  SAVE_APPLIANCE_NAVBAR_LIST: 'saveApplianceNavbarList',
  SAVE_CHART_API_PAYLOAD: 'saveChartApiPayload',
  SIMILAR_HOMES_API_ERROR: 'similarHomesApiError'
};

export const PREFERENCE = {
  TABS: {
    CONTACT_INFO: "contactInfo",
    ALERT_TYPE: "alertType"
  },
  URLS: {
    contactInfo: "contact-info",
    alertType: "alert-type"
  },
  EDIT: "edit",
  SAVE_CHANGES: "Save Changes"
};

export const SCREEN_BREAKPOINTS = {
  LARGE_DESKTOP: "1200",
  DESKTOP: "992",
  TABLETS: "768",
  MOBILE: "576"
};

export const HOME = "HOME";

export const ALLOWED_QUERY_PARAMS =  ['event-type','tab-type','ref-type','feedback-type', 'event-type', 'locale', 'delivery-mode', 'reco-id', 'question-id', 'widget-name', 'hide-page-title', 'widget-id', 'app-id'];

export const HOME_INSIGHTS_DATA_FEEDTYPE = ['INTERESTING_INSIGHTS', 'ENERGY_SAVING_RECO'];

export const PIE_CHART_SIZE = {
  LARGE : {
    outerSlice : {
      size : '260px',
      innerSize : '243px'
    },
    innerRing : {
      size : '250px',
      innerSize : '210px'
    },
    innerSlice : {
      size : '250px',
      innerSize : '210px'
    }
  },
  MEDIUM : {
    outerSlice : {
      size : '210px',
      innerSize : '190px'
    },
    innerRing : {
      size : '200px',
      innerSize : '160px'
    },
    innerSlice : {
      size : '200px',
      innerSize : '190px'
    }
  },
  SMALL : {
    outerSlice : {
      size : '150px',
      innerSize : '143px'
    },
    innerRing : {
      size : '143px',
      innerSize : '115px'
    },
    innerSlice : {
      size : '150px',
      innerSize : '107px'
    }
  }
};

export const PAGE_EVENT_NAMES = {
  FAQ: "web.disagg101",
  FEEDBACK: "email.feedback",
  INSIGHTS: "web.app.dashboardv3Insight",
  RECOMMENDATIONS: "web.app.tips",
  DASHBOARD: "web.app.dashboardv3",
  PREFERENCE: "web.app.preferences",
  SURVEY: "web.homeAssessmentSurvey",
  MARKETPLACE : "web.marketplace"
};

export const EVENT_NAMES = {
  USAGE_COST_TOGGLE: 'usageCostToggle',
  WEATHER_TOGGLE: 'weatherToggle',
  FUEL_TOGGLE: 'fuelToggle',
};

export const ARROWS = {
  LEFT: "arrow-left",
  RIGHT: "arrow-right"
};

export const INSIGHTS_PAGES = {
  USAGE: 'USAGE',
  MONTHLY_SUMMARY: 'MONTHLY SUMMARY',
  SIMILAR_HOMES: 'SIMILAR HOMES',
  BILL_ANALYSIS: 'BILL ANALYSIS'
};

export const DASHBOARD = {
  READ_MORE_INSIGHT: 'readMoreInsight',
  HOME_ASSESSMENT_SURVEY: 'homeAssessmentSurvey'
}


export const SHC_BC = 'SHC_BC';

export const NONE = 'None';

export const RECO_TYPE = {
  CAROUSEL: "carousel",
  PROGRAM : "program",
  GRID: "grid"
};

export const SURVEY_QUESTION_TYPES = {
  SINGLE: "SINGLE",
  MULTIPLE: "MULTIPLE",
  NUMBER: "NUMBER"
};

export const SSO_AUTH_ERROR = {
  "000" : "Invalid Request",
  "001": "Invalid Token",
  "002": "Token Expired",
  "003": "Invalid Web Request",
  "010": "Internal Error",
  "011": "Unknown User",
  "012": "Multiple User found"
};

export const SSO_DESTINATION = {
  DASHBOARD: "dashboard",
  PREFERENCES: "userPreferences",
  SURVEY: "survey"
};

export const SURVEY_QUESTION_STATE = {
  ANSWERED: "ANSWERED",
  UNANSWERED: "UNANSWERED"
};

export const RECO_RESPONSE = {
  LIKE : "Like",
  DISLIKE : "dislike",
  UNLIKE : null
}

export const SLICK_ITEMS_TO_SHOW = {
  DESKTOP : 3,
  TABLETS : 2,
  MOBILE : 1
}

export const MAX_BC_TO_SHOW = 13;

export const HOME_PAGE_WIDGETS = {
  WEATHER : "Weather",
  CONSUMPTION_BREAKDOWN : "Consumption Breakdown",
  USAGE_SUMMARY : "Usage Summary",
  USAGE_HISTORY : "Usage History",
  INSIGHTS_FEED : "Insights Feed",
  SMART_RECO : "Smart Recommendation",
  ENVIRONMENT : "Environment"
}

export const LEARN_MORE = "Learn More"

export const HOUR_APPLIANCES_LIST_NAME = {
  '1': "AC1",
  '2': "AC2",
  '3': "Refrigerator"
}

export const HOUR_APPLIANCES_LIST_COLOR = {
  '1': "rgb(250,109,159)",
  '2': "rgb(200,112,229)",
  '3': "rgb(122,243,244)"
}

export const POLLING_TIME = {
  DAY : 60000,
  HOUR : 60000
}
